export default __webpack_public_path__ + "static/media/77169-buy-and-sell-online.85be2347.gif";